import { Component } from '@angular/core';

@Component({
  selector: 'daccs-deposits-eod-container',
  templateUrl: './deposits-eod-container.component.html',
  styleUrls: ['./deposits-eod-container.component.scss']
})
export class DepositsEodContainerComponent {

}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/views/daily-recon/eod-recon/components/deposits-eod-container/deposits-eod-container.component.ts